module.exports = __webpack_public_path__ + "img/xlsx.29b87a8c.svg";